import { memo } from 'react';
import Button from 'components/UI/Button';
import { LoginIcon } from 'components/Icons';

const ConnectWalletButton = ({
    text,
    onClick,
}) => (
    <Button
        data-testid="connect-wallet"
        className="with-icon dropdown connect-wallet-btn"
        onClick={onClick}
    >
        <LoginIcon />
        <span>{text}</span>
    </Button>
);

export default memo(ConnectWalletButton);
